<template>
	<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="10.5" height="10.527" viewBox="0 0 10.5 10.527">
		<defs>
			<clipPath id="clip-path-StrikeSvg">
				<rect id="Rectangle_9266" data-name="Rectangle 9266" width="10.5" height="10.527" transform="translate(0 0)" fill="#5a677d" />
			</clipPath>
			<clipPath id="clip-path-StrikeSvg-2">
				<rect
					id="Rectangle_9138"
					data-name="Rectangle 9138"
					width="6.597"
					height="10.516"
					transform="translate(1.951 0.002)"
					fill="#5a677d"
				/>
			</clipPath>
		</defs>
		<g id="Group_30566" data-name="Group 30566" transform="translate(-1501.894 -466)">
			<g id="Group_30564" data-name="Group 30564" transform="translate(1501.894 466)" clip-path="url(#clip-path-StrikeSvg)">
				<path
					id="Path_21061"
					data-name="Path 21061"
					d="M10.125,4.51H.375A.375.375,0,0,0,0,4.884v.75a.375.375,0,0,0,.374.376h9.751a.375.375,0,0,0,.375-.375v-.75a.375.375,0,0,0-.375-.375"
					fill="#5a677d"
				/>
			</g>
			<g id="Group_30565" data-name="Group 30565" transform="translate(1501.894 465.998)">
				<g id="Group_30070" data-name="Group 30070" clip-path="url(#clip-path-StrikeSvg-2)">
					<path
						id="Path_21015"
						data-name="Path 21015"
						d="M2.888,7.252A3.212,3.212,0,0,0,5.429,8.625c.936,0,1.392-.564,1.392-1.144,0-.763-.7-1.023-1.618-1.3C3.894,5.8,2.217,5.344,2.217,3.07A2.927,2.927,0,0,1,5,0c.085,0,.17,0,.255,0A3.934,3.934,0,0,1,8.368,1.421L7.422,3.009A3.04,3.04,0,0,0,5.13,1.895c-.767,0-1.179.427-1.179,1.037,0,.687.671.9,1.6,1.175,1.319.382,3,.886,3,3.145a2.985,2.985,0,0,1-2.677,3.261,2.947,2.947,0,0,1-.523.005A4.13,4.13,0,0,1,1.952,8.9Z"
						fill="#5a677d"
					/>
				</g>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'StrikeSvg',
};
</script>

<style scoped lang="scss"></style>
